<template lang="pug">
  .video-player
    .preview(
      v-if="options.image && !played"
      role="button"
      tabindex="0"
      @click="playVideo"
      @keydown.enter="playVideo"
      @keydown.space.prevent="playVideo"
    )
      .control-button
        span.control-icon
      img(:src="options.image.url" :alt="options.image.text || 'Preview'" loading="lazy")
    video.player(
      v-else
      :src="computedVideoUrl"
      playsinline
      :poster="playerOptions.poster"
      :controls="playerOptions.controls"
      :autoplay="playerOptions.autoplay"
      :muted="options.hoverVideo"
      :loop="options.loop"
      @play="onPlay"
      @pause="onPause"
      @ready="onReady"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
      ref="videoPlayer"
    )
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'VideoPlayer',

    emits: ['play', 'pause', 'ready'],
    props: {
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        played: false,
      };
    },
    computed: {
      ...mapState('global', ['windowData']),

      player() {
        return this.$refs.videoPlayer;
      },

      computedVideoUrl() {
        let url = this.options.url || '';
        if (this.windowData && this.windowData.isIosDevice) {
          url += '#t=0.001';
        }
        return url;
      },

      playerOptions() {
        let { image, autoplay = false, controls = true } = this.options;
        let posterUrl = image?.url ?? null;
        // add 16:9 aspect ratio to the poster image
        if (posterUrl) {
          if (posterUrl.includes('?')) {
            posterUrl += '&h=225&w=400&fit=crop';
          } else {
            posterUrl += '?h=225&w=400&fit=crop';
          }
        }

        return {
          controls,
          autoplay,
          poster: posterUrl,
        };
      },
    },
    methods: {
      onPlay() {
        this.$emit('play');
      },

      playVideo() {
        this.played = true;
        this.$nextTick(() => {
          this.player.play();
        });
      },

      mouseOver() {
        if (this.options.hoverVideo) {
          this.onPlay();
          this.playVideo();
        }
      },

      mouseLeave() {
        if (this.options.hoverVideo) {
          this.onPause();
          this.$nextTick(() => {
            this.player.pause();
          });
        }
      },

      onPause() {
        this.$emit('pause');
      },

      onReady() {
        this.$emit('ready');
      },
    },
  };
</script>

<style lang="stylus" scoped>
.video-player
  position relative
  width 100%
  height 100%
  aspect-ratio 16 / 9

.preview
  cursor pointer
  display flex
  aspect-ratio 16 / 9
  align-items center
  justify-content center

  .control-button
    position absolute
    z-index: 3
    width 4em
    height 4em
    left 50%
    top 50%
    margin-left -2em
    margin-top -2em
    border 0.2em solid #fff
    border-radius 50%

    .control-icon
      position absolute
      width 0
      height 0
      left 50%
      top 50%
      border 1em solid transparent
      border-left-color #fff
      border-left-width 1.732em
      border-right-width 1.732em
      margin-top -1em
      margin-left -0.578em

  img
    width 100%
    height 100%
    object-fit cover

.player
  aspect-ratio 16 / 9
  width 100%
  height 100%
</style>
